import { checkIsFilmmakersProfile, checkIsPerformer } from "shared-auth";
import { HeapService } from "../heap";

export enum JobsFeedUsageEventPrefix {
  Agent = "Agent -",
  Performer = "Performer -",
}

export enum JobsFeedUsageEvents {
  TabsMatchingMyFilter = "Tabs: Matching my filter",
  TabsAllPaid = "Tabs: All paid",
  TabsAllOpportunities = "Tabs: All opportunities",
  LhnMatchingMyFilter = "LHN: Matching my filter",
  LhnAllPaid = "LHN: All paid",
  LhnAllOpportunities = "LHN: All opportunities",
  LhnJobsfeedSettings = "LHN: Jobsfeed settings",
  CtaChangeFilterSettings = "CTA: Change filter settings",
  FilterProductionType = "Filter: Production type",
  FilterContract = "Filter: Contract type",
  FilterShowRoleType = "Filter: Show role type",
  FilterSort = "Filter: Sort",
  FilterShowOpenClose = "Filter: Show open/close role",
  FilterDateSent = "Filter: Date sent",
  FilterViewAllFilters = "Filter: View all filters",
  Refresh = "Refresh",
  SelectAll = "Select all",
  MarkAsRead = "Mark as read",
  MarkAsUnread = "Mark as unread",
}

export function sendJobsfeedUsageHeapEventWithUserPrefix(event: string) {
  const isPerformer = checkIsPerformer() || checkIsFilmmakersProfile();
  const prefix = isPerformer
    ? JobsFeedUsageEventPrefix.Performer
    : JobsFeedUsageEventPrefix.Agent;

  return HeapService.track(`${prefix} ${event}`);
}
